const CALENDAR_ADDED_KEY = 'inquiry_events_added_to_calendar'

function getCalendarAddedStorageKey(userId?: number | null) {
  return `${CALENDAR_ADDED_KEY}_${userId ?? 'guest'}`
}

export function getAddedToCalendarIds(userId?: number | null): number[] {
  try {
    const raw = localStorage.getItem(getCalendarAddedStorageKey(userId))
    if (!raw) return []
    const parsed = JSON.parse(raw)
    return Array.isArray(parsed) ? parsed.map(Number).filter(Boolean) : []
  } catch {
    return []
  }
}

export function isInquiryAddedToCalendar(
  eventId: number,
  userId?: number | null
): boolean {
  return getAddedToCalendarIds(userId).includes(eventId)
}

export function markEventAddedToCalendar(
  eventId: number,
  userId?: number | null
) {
  const ids = getAddedToCalendarIds(userId)
  if (ids.includes(eventId)) return
  localStorage.setItem(
    getCalendarAddedStorageKey(userId),
    JSON.stringify([...ids, eventId])
  )
}

export function unmarkEventAddedToCalendar(
  eventId: number,
  userId?: number | null
) {
  const ids = getAddedToCalendarIds(userId).filter((id) => id !== eventId)
  localStorage.setItem(getCalendarAddedStorageKey(userId), JSON.stringify(ids))
}
